export default {
  name: 'ReportCostTypeExpand',
  props: {
    data: Object
  },
  computed: {
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    tableHeaders () {
      const headers = [];
      headers.push({ key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' });
      headers.push({ key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' });
      headers.push({ key: 'report_config_id', label: this.$t(''), format: 'formatFromConfig', configKey: 'report_configs', configParam: 'name' });
      headers.push({ key: 'price', label: this.$t('general.price'), format: 'formatDecimal', precision: 2 });
      return headers;
    }
  }
}
